import React, { useState, useRef } from "react";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";

interface IQuestionProps {
  isOpen: boolean;
}

const UpArrow = styled.div`
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAk0lEQVRIie3UQQrCMBCF4S/qDXpMF3oUwdqFHs0zeASpmwihWkyTusuDQJIZ/jcThtDUVKuwMPcY9yeMaxfSR+iIGzb/gq9qEjAk0Etc7/Ng2TN/wNPKr/Eu4Kyykzl4Gi82+QWvMsmFF5l8g+e0nW2SwpdOx3Ta+mlCVwGfM+lgF4MPHLBV/g2M2OOOZ2Q2Na2gF4pwQ0nCrOImAAAAAElFTkSuQmCC");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  height: 30px;
  width: 30px;
  margin-top: 10px;
  transition: 0.2s ease-in-out;
  transform-origin: center;
`;

const DownArrow = styled.div`
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAiklEQVRIie2Tuw2AMAwFDxghu1CwFLAJEp8CJmIqaFxYQYEEI6o8KVKKlzsXDuTkWFOpews0wG7gFUAP1D7HAYecRYpv4IviOL8wGSQ+fAqVRlXagDISrodb796lSpLgIUnoUWzvlcQEf4J8AtcSvR2zHOtKXyR64k8mf5JEw1M/Uyf3QUQ5OT/kBEmoPwh1vkJ1AAAAAElFTkSuQmCC");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  height: 30px;
  width: 30px;
  margin-top: 10px;
  transition: 0.2s ease-in-out;
  transform-origin: center;
`;

const ThumbsUpIcon = styled.div`
  background-image: url("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");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  height: 30px;
  width: 30px;
  margin-top: 10px;
`;

const GreenHeader = styled.div`
  background-color: #7ff9c0;
  height: 20px;
  margin-bottom: 15px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 12px;
`;

const GreenHeaderText = styled.h1`
  font-size: 23px;
  text-align: center;
  font-weight: bolder;
  margin-top: -15px;
  font-style: italic;
`;
const Body = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
`;
const AccordionTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  background-color: #7ff9c0;
  padding: 1px;
  margin-top: 0px;
  margin-bottom: 1px;
  border-bottom-color: gray;
  border-bottom-width: 1px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
`;
const Accordion = styled.div`
  background-color: #7ff9c0;
  height: 50px;
  margin-bottom: 2px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 12px;
`;
const AccordionContent = styled.div<IQuestionProps>`
  background-color: #edf2f6;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  padding: 1px;
  margin-top: 0px;
  margin-bottom: 1px;
  border-bottom-width: 1px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  transition: ${(props) => (props.isOpen ? "max-height 1s ease-in-out" : "")};
`;
const HighlightedTextBackground = styled.div`
  background-image: url("data:image/png;base64,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");
  background-size: 50px 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-color: #7ff9c0;
  margin-bottom: 50px;
  margin-top: 50px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 10px;
  &p {
    padding-top: 30px !important;
  }
  text-align: left;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
`;

export function getTitle(data: any, searchString: string) {
  return data.allDatoCmsGeneralGuildeline?.edges.find(
    (x) => x.node?.slug === `${searchString}`
  ).node?.seo?.title;
}

export function getDescription(data: any, searchString: string) {
  return data.allDatoCmsGeneralGuildeline?.edges.find(
    (x) => x.node?.slug === `${searchString}`
  ).node?.seo?.description;
}

export function getPageHeader(
  data: any,
  searchString: string,
  isMobile: boolean
) {
  if (isMobile) {
    const {
      mobilePageTitleLine1,
      mobilePageTitleLine2,
    } = data.allDatoCmsGeneralGuildeline?.edges.find(
      (x) => x.node?.slug === `${searchString}`
    ).node;

    return { mobilePageTitleLine1, mobilePageTitleLine2 };
  } else {
    const {
      pageTitleLine1,
      pageTitleLine2,
    } = data.allDatoCmsGeneralGuildeline?.edges.find(
      (x) => x.node?.slug === `${searchString}`
    ).node;

    return { pageTitleLine1, pageTitleLine2 };
  }
}

export function GeneratePage(
  data: any,
  searchString: string,
  isMobile: boolean
): JSX.Element[] {
  const [selectedQuestionId, setSelectedQuestionId] = useState("");
  const AccordionContentRef = useRef<HTMLDivElement>(null);

  const htmlArr = [];
  const selectedQuestion = (id: string) => {
    if (id === selectedQuestionId) {
      setSelectedQuestionId("");
    } else {
      setSelectedQuestionId(id);
    }
  };
  const dataToLoop = data?.allDatoCmsGeneralGuildeline?.edges.find(
    (x) => x.node.slug === `${searchString}`
  ).node;
  for (let i = 0; i < dataToLoop?.contentBlocks.length; i++) {
    if (dataToLoop.contentBlocks[i].greenHeader) {
      const greenHeader = (
        <GreenHeader>
          <GreenHeaderText>
            {dataToLoop.contentBlocks[i].greenHeader.toUpperCase()}
          </GreenHeaderText>
        </GreenHeader>
      );
      htmlArr.push(greenHeader);
    }
    if (dataToLoop.contentBlocks[i].htmlContent) {
      const content = dataToLoop.contentBlocks[i].htmlContent.replace(
        "<ul",
        '<ul style="list-style: auto;margin: 10px;padding:24px;"'
      );

      htmlArr.push(<Body dangerouslySetInnerHTML={{ __html: content }}></Body>);
    }

    if (isMobile && dataToLoop.contentBlocks[i].mobileImage) {
      const img = dataToLoop.contentBlocks[i].mobileImage.url;
      const imgUrl = <img src={img} style={{ marginBottom: "50px" }} />;
      htmlArr.push(imgUrl);
    }

    if (!isMobile && dataToLoop.contentBlocks[i].desktopImage) {
      const img = dataToLoop.contentBlocks[i].desktopImage.url;
      const imgUrl = <img src={img} style={{ marginBottom: "50px" }} />;
      htmlArr.push(imgUrl);
    }

    if (dataToLoop.contentBlocks[i].answer) {
      htmlArr.push(
        AccordionT(
          dataToLoop.contentBlocks[i].question,
          dataToLoop.contentBlocks[i].answer,
          i,
          selectedQuestionId,
          AccordionContentRef,
          selectedQuestion
        )
      );
    }
    if (dataToLoop.contentBlocks[i]?.id?.includes("HighlightedText")) {
      const text = `<p style="margin-top:10px;margin-bottom:10px;margin-left:70px;margin-right:20px;">${dataToLoop.contentBlocks[i]?.text}</p>`;
      htmlArr.push(
        <HighlightedTextBackground
          dangerouslySetInnerHTML={{
            __html: text,
          }}></HighlightedTextBackground>
      );
    }
  }
  htmlArr.push(getDesktopFooterImage(data, searchString));
  return htmlArr;
}

export function AccordionT(
  question: string,
  answer: string,
  id: number,
  selectedId: string,
  AccordionContentRef: any,
  selectedQuestion?: (id: string) => void
) {
  const _question = `<p style="margin-left:30px!important;margin-top:-7px;margin-bottom:10px;">${question}</p>`;
  return (
    <div>
      <AccordionTitle onClick={() => selectedQuestion(id.toString())}>
        <div
          id={id.toString()}
          style={{
            boxSizing: "border-box",
            padding: "13px",
            marginLeft: "20px",
          }}
          dangerouslySetInnerHTML={{ __html: _question }}></div>
        <div>{selectedId === id.toString() ? <DownArrow /> : <UpArrow />}</div>
      </AccordionTitle>
      {selectedId === id.toString() && (
        <AccordionContent
          isOpen={selectedId === id.toString()}
          ref={AccordionContentRef}
          style={{
            boxSizing: "border-box",
            padding: "13px",
            paddingLeft: "35px",
            transition: "max-height 1s ease-in-out",
          }}
          dangerouslySetInnerHTML={{ __html: answer }}></AccordionContent>
      )}
    </div>
  );
}

export function getDesktopFooterImage(data: any, searchString: string) {
  const url = data.allDatoCmsGeneralGuildeline?.edges.find(
    (x) => x.node.slug === `${searchString}`
  ).node?.desktopFooterImage[0]?.image.url;
  if (url) {
    return <img src={url} style={{ marginBottom: "50px" }} />;
  }
}

const Query = () => {
  return useStaticQuery(graphql`
    query {
      allDatoCmsGeneralGuildeline {
        edges {
          node {
            locale
            slug
            contentBlocks {
              ... on DatoCmsNewsHtml {
                id
                htmlContent
                model {
                  apiKey
                }
              }
              ... on DatoCmsGatsbyLink {
                id
                text
                hyperlink
                model {
                  apiKey
                }
              }
              ... on DatoCmsTransitionImage {
                id
                model {
                  apiKey
                }
                mobileImage {
                  url
                  alt
                }
                desktopImage {
                  url
                  alt
                }
              }
              ... on DatoCmsImage {
                id
                isBottomSeparatorLine
                desktopImage {
                  alt
                  url
                }
                mobileImage {
                  alt
                  url
                }
                model {
                  apiKey
                  modularBlock
                }
                locale
              }
              ... on DatoCmsQuestionAndAnswer {
                id
                answer
                question
                model {
                  apiKey
                }
              }
              ... on DatoCmsGreenHighlightedText {
                id
                text
              }
              ... on DatoCmsRulesGreenHeader {
                id
                greenHeader
              }
              ... on DatoCmsScrollableImage {
                id
                thinHeaderText
                isBottomMarginDisabled
                subtitleHeader
                image {
                  height
                  width
                  url
                  alt
                }
                model {
                  apiKey
                }
              }
            }
            pageTitleLine1
            pageTitleLine2
            mobilePageTitleLine1
            mobilePageTitleLine2
            mobileHeaderImage {
              mobileImage {
                url
                width
                title
              }
              title
              content
            }
            seo {
              title
              description
              image {
                url
              }
            }
            desktopFooterImage {
              image {
                url
              }
              line1
              line2
            }
          }
        }
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);
};
export default Query;
